import { Paper, Typography } from "@material-ui/core";
import React from "react";
import ReactPlayer from "react-player";

const VideoDetail = ({ video }) => {
  if (!video) {
    return null;
  }
  // console.log(video);
  const videoSrc = `https://www.youtube.com/embed/${video.id.videoId}`;
  console.log(video.snippet.description);
  return (
    <React.Fragment>
      <div className="video_played">
        <ReactPlayer
          className="video"
          // url="https://www.youtube.com/watch?v=ysz5S6PUM-U"
          url={videoSrc}
          controls={true}
        />
        <h1>
          {video.snippet.title}
        </h1>
        <h2>
          {video.snippet.channelTitle}
        </h2>
        {/* <span>Description</span>
        <div className="see_more">
          <p>{video.snippet.description}</p>
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default VideoDetail;
